import {Component, OnInit} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {PromotionDto} from "../../types/promotions.types";
import {PromotionsApiService} from "../../api/promotions-api.service";
import {MessageHelper} from "../../../../core/helper/message-helper";
import {AppMessageService} from "../../../../core/service/app-message.service";


@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html',
  styleUrls:['promotions.component.scss']
})
export class PromotionsComponent extends CoreComponent implements OnInit {

  promotions: PromotionDto[] | undefined;

  constructor(protected promotionsApiService: PromotionsApiService,
              protected messageService: AppMessageService,) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();

    this.refreshComponent();
  }


  refreshComponent() {

    // retrieve notifications
    this.promotionsApiService.getPromotions().subscribe(value => {
      this.promotions = value;
      this.initialized = true;
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    });


  }

}
